import { DEFAULT_URL } from './constants.js';
class GasPriceService {
    assetsService;
    fetchival;
    pricingService;
    url;
    constructor(params) {
        this.assetsService = params.assetsService;
        this.fetchival = params.fetchival;
        this.pricingService = params.pricingService;
        this.url = new URL(params.url || DEFAULT_URL);
    }
    async fetchGasPrice() {
        const hexGasPrice = await this.fetchival(this.url).get({
            method: 'eth_gasPrice',
        });
        return parseInt(hexGasPrice);
    }
    getMinGasPriceMultiplier() {
        return 1_500_000;
    }
    async getMinUsdLimitBasedOnGasPrice(assetId) {
        const asset = await this.assetsService.getOneById(assetId);
        if (!asset || asset.network !== 'ethereum') {
            return;
        }
        const gasPrice = await this.fetchGasPrice();
        const minGasPriceMultiplier = this.getMinGasPriceMultiplier();
        const [baseAsset, ethPrice] = await Promise.all([
            this.assetsService.getOneById('ETH'),
            this.pricingService.getPrices(['ETH']),
        ]);
        if (!baseAsset || !ethPrice['ETH']) {
            return;
        }
        const minLimitBasedOnGasPrice = baseAsset.currency.baseUnit(gasPrice).mul(minGasPriceMultiplier);
        const ethPriceInUsd = ethPrice['ETH'];
        return minLimitBasedOnGasPrice.mul(ethPriceInUsd).toDefaultNumber();
    }
}
export default GasPriceService;
